import React from 'react';

const Error = ({ msg }) => {
  return <div className="col-span-12">{msg}</div>;
};

export default Error;
